import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { activateSimCardMsg, orderNewMsg, subChangePendingMsg, t } from '../../common/i18n/index.js';
import { SimCardNumber } from '../SimCardNumber/SimCardNumber.js';
import { SimCardType } from '../SimCardType/SimCardType.js';
import type { SimCardConfiguration } from '../../common/types/subscription.js';
import type { JSX } from 'react';

import './SimCard.scss';

export interface SimCardProps {
  hasPendingActions: boolean;
  simCardConfig: SimCardConfiguration;
  sourceIsExternal: boolean;
  onClickOrderSim?: () => void;
  onClickSimActivation?: () => void;
  simCardChangeAllowed?: boolean;
  actions?: boolean;
  hasEsimQrCode?: boolean;
  singleColumn?: boolean;
}

export const SimCard = ({
  hasPendingActions,
  simCardConfig,
  onClickSimActivation,
  onClickOrderSim,
  sourceIsExternal,
  simCardChangeAllowed,
  actions = true,
  hasEsimQrCode = false,
  singleColumn = false,
}: SimCardProps): JSX.Element => {
  if (hasPendingActions) {
    return (
      <div>
        <p>{t.MQHO(subChangePendingMsg)}</p>
        <div className={dsClass.PADDING_BOTTOM_4} />
      </div>
    );
  }

  const actionButtons = (
    <>
      <CL.Button
        color="light"
        size="s"
        id="activate-sim-card-button"
        className="of-sim-card__button1"
        onClick={() => onClickSimActivation && onClickSimActivation()}
        disabled={!(simCardChangeAllowed === undefined || simCardChangeAllowed || hasEsimQrCode)}
      >
        {t.M1E7(activateSimCardMsg)}
      </CL.Button>
      <CL.Button
        color="light"
        size="s"
        id="order-new-sim-button"
        className="of-sim-card__button2"
        onClick={() => onClickOrderSim && onClickOrderSim()}
        disabled={simCardChangeAllowed === false}
      >
        {t.PMFC(orderNewMsg)}
      </CL.Button>
    </>
  );

  return (
    <div className="of-sim-card">
      <CL.Description
        columns={singleColumn ? 1 : 2}
        items={[
          ...(sourceIsExternal ? [] : [{ description: <SimCardType simType={simCardConfig.simType} /> }]),
          { description: <SimCardNumber simCardNumber={simCardConfig.simCardNumber} /> },
        ]}
      />

      {actions && !sourceIsExternal && (
        <div className={dsClass.PADDING_BOTTOM_4}>
          <div className="of-sim-card__container">{actionButtons}</div>
        </div>
      )}
    </div>
  );
};
